import React from "react";
import { FormattedNumber } from "react-intl";
import { fetchPrizeAmount, isEmptyOrNil } from "../utils";
import { truncate } from "../../../../lib/utils/stringFunctions";

const TrophyEllipse = ({ currencyCode, Trophy, placeData }) => {
  if (isEmptyOrNil(placeData)) {
    return null;
  }

  const { display_title: title } = placeData;

  return (
    <div className="trophy-wrapper">
      <Trophy />
      <div className="ellipse">
        <img src={placeData.image} aria-hidden="true" width="80" />
      </div>
      <div className="trophy-content">
        <div className="leader-titles" title={title}>
          {truncate(title, 26)}
        </div>
        <div className="trophy-prize">Prize</div>
        <div className="trophy-amount">
          <FormattedNumber
            value={fetchPrizeAmount(placeData)}
            currencyDisplay="symbol"
            currency={currencyCode}
            style="currency"
          />
        </div>
      </div>
    </div>
  );
};

export default TrophyEllipse;
